import React from 'react';

export default function ErrorPage() {
  return (
    <h1>Unexpected error occurred</h1>
  );
}
